// clientId is required param @see https://developer.paypal.com/sdk/js/reference/
// we return empty string in order to prevent flooding PayPal CDN by unnecessary calls
export const getPayPalConnectionString = (clientId: string | null, currency: string): string =>
  clientId
    ? `https://www.paypal.com/sdk/js?client-id=${clientId}&disable-funding=credit,card&intent=authorize&currency=${currency}`
    : '';
